<template>
  <div id="mycombo">
    <mt-header title="我的套餐">
      <mt-button icon="back" slot="left" @click="goBack">返回</mt-button>
      <mt-button @click="comboRecordView" slot="right">购买记录</mt-button>
    </mt-header>
    <div>
      <div v-show="isNotExist" class="mycb notExist">
        <img src="/static/img/combo/comboGrey.png"/>
        <div><span>您的套餐已用完,请重新购买</span></div>
      </div>
      <div class="buyCombo">
        <mt-button class="login-btn" size="large" type="primary" @click="buyCombo()">购买套餐</mt-button>
      </div>
      <div v-show="!isNotExist">
        <ul>
          <li v-for="(item, index) in itemsCCIVO" :key="index">
            <div class="mycb">
              <div class="isExist">
                <img src="/static/img/combo/combo.png"/>
                <div><span>{{item.comboName}}</span></div>

                <div v-show="item.status == '0'" class="comboName-status" ><span>
                      正在使用
                </span></div>
                <div v-show="item.status == '2'" class="comboName-status"><span>
                      待使用
                </span></div>
              </div>
              <hr>
              <div style="line-height: 2rem;">
                <div class="comboPayMode"><span>套餐内次数</span></div>
                <div class="comboNum"><span>{{item.num}}次</span><span class="totalNum"> ( 共{{item.number}}次 )</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>


    </div>

  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import cheader from '@/components/header';
  export default {
    data () {
      return {
        isNotExist: true,
        itemsCCIVO: [1, 2, 3, 4]
      }
    },
    methods: {
      comboRecordView: function () {
        this.$router.push({
          path: "/combo/comboRecord",
          name: 'comboRecord'
        })
      },
      buyCombo: function () {
        this.$router.push({
          path: "/combo/buyCombo",
          name: 'buyCombo'
        })
      },
      goBack: function () {
        this.$router.push('/main');
        //history.go(-1); //后退1页
        localStorage.setItem("tab-selected", "tab-container3");
      },
      sure: function () {
        this.$toast('帐号密码错误');
      },
      showPass: function () {
        this.isPass = false;
        this.inputType = 'text';
      },
      hidePass: function () {
        this.isPass = true;
        this.inputType = 'password';
      },
      fetcchMsg(){
        var _myCombosync_url = domain("_myCombosync");
        var that = this;
        that.$http.post(
          _myCombosync_url,
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
          console.log(response);
            this.itemsCCIVO = [response.body.data.cciVO,...response.body.data.cciVOReady];
            //console.log(this.itemsCCIVO)
            var length = this.itemsCCIVO.length;
            if (length !== 0) {
              this.isNotExist = false;
            }
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
        //   Indicator.close();
        })
      }
    },
    components: {},
    mounted: function () {
      this.fetcchMsg();
    }

  }
</script>
<style>

  #mycombo {
    background-color: #ECECEC;
    width: 100%;
    min-height: 100%;
  }

  .buyCombo {
    width: 90%;
    margin: auto;
    margin-top: 0.5rem;
  }

  .mycb {
    margin-left: 4%;
    margin-right: 4%;
    background-color: #ffffff;
    margin-top: 1rem;
    font-size: 1rem;
    color: #7d7d7d;
    font-family: "Microsoft YaHei";
    border-radius: 5px;
  }

  .notExist {
    text-align: center;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .notExist img {
    width: 40px;
  }

  .isExist {
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 0.5rem;
  }
  .isExist span{
    font-size: 0.9rem;
    color:#7d7d7d;
  }
  .isExist img {
    width: 40px;
  }

  .comboPayMode {
    display: inline;
    padding-left: 10px;
    font-size: 0.9rem;
  }
  .mycb hr{
    width:96%;
    margin: 0 auto;
  }
  .comboNum {
    float: right;
    padding-right: 10px;
    font-size: 0.9rem;
  }

  .totalNum {
    color: #c1c1c1;
    padding: 0.2rem;
  }
  .comboName-status{
  }


</style>



// WEBPACK FOOTER //
// src/module/combo/mycombo.vue